import { Link } from 'react-router-dom';
import { useLocalizedPath } from '@/hooks/useI18n';
import { useTranslation } from '@/hooks/useTranslation';
import { Container } from '@/components/Container';
import { ArrowRight, MapPin, Waves, Sun, UtensilsCrossed } from 'lucide-react';

export function ComparativoVilarejosSection() {
  const localize = useLocalizedPath();
  const { t } = useTranslation();
  return (
    <section id="comparativo-vilas" className="py-16 bg-white">
      <Container>
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
              {t('guide.comparativoVilarejos.overline')}
            </span>
            <h2 className="font-display text-3xl text-warm-dark mt-2 tracking-wide">
              {t('guide.comparativoVilarejos.title')}
            </h2>
            <p className="font-editorial text-lg text-warm-gray mt-2">
              {t('guide.comparativoVilarejos.subtitle')}
            </p>
          </div>

          <div className="bg-sand-50 rounded-2xl border border-sand-200 p-6 md:p-8">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              {/* Nova Brasília */}
              <div className="bg-white rounded-xl p-5 border border-sand-200">
                <h3 className="font-display text-xl text-teal-deep mb-3 tracking-wide">
                  {t('guide.mapaMental.village.novaBrasilia')}
                </h3>
                <ul className="space-y-2 font-body text-sm text-warm-gray">
                  <li className="flex items-center gap-2">
                    <Waves className="w-4 h-4 text-ocean-500 flex-shrink-0" />
                    {t('guide.comparativoVilarejos.nbFeature1')}
                  </li>
                  <li className="flex items-center gap-2">
                    <UtensilsCrossed className="w-4 h-4 text-ocean-500 flex-shrink-0" />
                    {t('guide.comparativoVilarejos.nbFeature2')}
                  </li>
                  <li className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-ocean-500 flex-shrink-0" />
                    {t('guide.comparativoVilarejos.nbFeature3')}
                  </li>
                </ul>
              </div>

              {/* Encantadas */}
              <div className="bg-white rounded-xl p-5 border border-sand-200">
                <h3 className="font-display text-xl text-coral mb-3 tracking-wide">
                  {t('guide.mapaMental.village.encantadas')}
                </h3>
                <ul className="space-y-2 font-body text-sm text-warm-gray">
                  <li className="flex items-center gap-2">
                    <Sun className="w-4 h-4 text-coral flex-shrink-0" />
                    {t('guide.comparativoVilarejos.encFeature1')}
                  </li>
                  <li className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-coral flex-shrink-0" />
                    {t('guide.comparativoVilarejos.encFeature2')}
                  </li>
                  <li className="flex items-center gap-2">
                    <Waves className="w-4 h-4 text-coral flex-shrink-0" />
                    {t('guide.comparativoVilarejos.encFeature3')}
                  </li>
                </ul>
              </div>
            </div>

            <Link
              to={localize('/nova-brasilia-vs-encantadas')}
              className="flex items-center justify-center gap-2 w-full bg-teal-deep text-white font-body font-semibold py-3 px-6 rounded-xl hover:bg-teal-dark transition-colors"
            >
              {t('guide.comparativoVilarejos.cta')}
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
}
